export const createGallerySlice = (set, get) => ({
  // Image state
  currentImage: null,
  originalImage: null,
  imageHistory: [],

  // Gallery actions
  setCurrentImage: (image) => set({ currentImage: image }),
  setOriginalImage: (image) => set({ originalImage: image }),

  addToImageHistory: (image, description) =>
    set((state) => ({
      imageHistory: [...state.imageHistory, { image, description, title: description, pinned: false, timestamp: Date.now() }],
      currentImage: image // Set as current image
    })),

  addOriginalToHistory: (image) =>
    set((state) => ({
      imageHistory: [...state.imageHistory, { image, description: 'Original image', title: 'Original image', pinned: false, timestamp: Date.now() }],
      originalImage: image,
      currentImage: image
    })),

  clearImageHistory: () => set({ imageHistory: [], }),

  updateHistoryItem: (index, updates) =>
    set((state) => {
      if (index < 0 || index >= state.imageHistory.length) return {}
      const next = [...state.imageHistory]
      next[index] = { ...next[index], ...updates }
      return { imageHistory: next }
    }),

  togglePin: (index) =>
    set((state) => {
      if (index < 0 || index >= state.imageHistory.length) return {}
      const next = [...state.imageHistory]
      next[index] = { ...next[index], pinned: !next[index].pinned }
      return { imageHistory: next }
    }),

  renameHistoryItem: (index, title) =>
    set((state) => {
      if (index < 0 || index >= state.imageHistory.length) return {}
      const next = [...state.imageHistory]
      next[index] = { ...next[index], title: title, description: next[index].description }
      return { imageHistory: next }
    }),

  removeFromHistory: (index) =>
    set((state) => {
      if (index < 0 || index >= state.imageHistory.length) return {}
      const next = [...state.imageHistory]
      const removedItem = next[index]
      next.splice(index, 1)
      
      // If we removed the current image, set to previous or original
      let newCurrentImage = state.currentImage
      if (removedItem.image === state.currentImage) {
        if (next.length > 0) {
          newCurrentImage = next[next.length - 1].image
        } else {
          newCurrentImage = state.originalImage
        }
      }
      
      return { imageHistory: next, currentImage: newCurrentImage }
    }),

  selectImageFromHistory: (index) => {
    const { imageHistory, setCurrentImage } = get()
    
    if (index >= 0 && index < imageHistory.length) {
      const selectedImage = imageHistory[index]
      setCurrentImage(selectedImage.image)
    }
  },
})